var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comming-others-wrapper"},[_c('section',[_c('BettingOffer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }